<app-alert></app-alert>
<main>
  <router-outlet *ngIf="loadComponent"></router-outlet>
</main>
